// /app/frontend/src/features/choral-intelligence/RecommendationCaution.jsx
import React from "react";

export default function RecommendationCaution({ caution }) {
  return (
    <div className="ci-caution" data-testid={`ci-caution-${caution.type}`}>
      <div className="ci-caution__label">{caution.label}</div>
      <div className="ci-caution__text">{caution.text}</div>
    </div>
  );
}
